import styles from './SmallButtons.module.scss'

export const PrimarySmallButton = ({ children, className, ...props }) => (
  <button {...props} className={[styles.primary, className].join(' ')}>
    {children}
  </button>
)

export const SecondarySmallButton = ({ children, className, ...props }) => (
  <button {...props} className={[styles.secondary, className].join(' ')}>
    {children}
  </button>
)

export const TerciarySmallButton = ({ children, className, ...props }) => (
  <button {...props} className={[styles.terciary, className].join(' ')}>
    {children}
  </button>
)
